import { useMemo } from "react";
import { brandIdentityApi, useAppSelector } from "@litres-core/store";

import type { ISubscriptionWithBranding } from "./interfaces";
import { getAvailableSubscriptions } from "./utils";

export const useAvailableSubscriptions = (): ISubscriptionWithBranding[] => {
  const { subscription, partner_subscriptions } = useAppSelector(
    state => state.foundationUser
  );
  const { data: userBrandIdentities = [] } =
    brandIdentityApi.useGetUserBrandIdentitiesQuery();
  return useMemo(() => {
    return getAvailableSubscriptions(
      subscription,
      partner_subscriptions,
      userBrandIdentities
    );
  }, [subscription, partner_subscriptions, userBrandIdentities]);
};
